import React from "react";

import { CardIcon, CardIconLarge } from "@molecules";

const CardIconGrid = ({ cards }) => {
  return (
    <div className="-mx-3 flex flex-wrap">
      {!!cards?.length &&
        cards.map(card => {
          if (card.type === "card") {
            return (
              <div className="mb-6 w-full px-3 md:w-1/3">
                <CardIcon {...card} />
              </div>
            );
          }
          if (card.type === "cardLarge") {
            return (
              <div className="mb-6 w-full px-3">
                <CardIconLarge {...card} />
              </div>
            );
          }
          return null;
        })}
    </div>
  );
};

CardIconGrid.defaultProps = {};

export default CardIconGrid;
